<template>
    <div>
        <el-button type="primary"
                   @click="startTour"
                   :disabled="!tourAvailable">
            {{ $t(tourNameKey) }}
        </el-button>

        <el-tour v-model="tourStart"
                 :target-area-clickable="true">

            <el-tour-step v-for="step in tourSteps"
                          :key="step.id"
                          :target="step.target"
                          :title="$t(step.title)"
                          :description="$t(step.description)" />

            <el-tour-step :target="searchControlTarget"
                          :title="$t('documentSearchTour.searchResults')"
                          :content-style="contentStyle">

                <div>{{ $t('documentSearchTour.searchResultsDescription') }}</div>

                <img class="screenshot"
                     src="@/images/Tours/search-result-view.png"
                     alt="search-result-view.png" />

            </el-tour-step>

        </el-tour>
    </div>
</template>

<script lang="ts">
    import { defineComponent } from 'vue';
    import { userGuideService } from '../userGuideService'

    export default defineComponent({
        props: {
            tourAvailable: {
                type: Boolean,
                default: false,
            }
        },
        data() {
            return {
                tourNameKey: "documentSearchTour.tourName",
                tourSteps: userGuideService.getDocumentSearch(),
                tourStart: false,
                searchControlTarget: "#search-control",
                contentStyle: { width: '1500px' },
            };
        },
        methods: {
            startTour() {
                const result = document.getElementById("shortcut-button");
                if (result != null) {
                    result.click();
                }
                this.tourStart = true;
            },
        },
    })
</script>

<style scoped>
    .screenshot {
        max-width: 100%;
        margin-top: 10px;
        margin-bottom: 10px;
    }
</style>